


































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { useThemeStore } from "@/shared/store/theme";

@Component
export default class GuidelinesModal extends Vue {
  themeStore = useThemeStore();
}
